import { defineWorld } from "@latticexyz/world";

export default defineWorld({
  tables: {
    GlobalNonce: {
      schema: {
        nonce: "uint256",
      },
      key: [],
    },
    MatchConfig: {
      schema: {
        matchDuration: "uint256",
        matchSize: "uint8",
      },
      key: [],
    },
    MatchCounter: {
      schema: {
        value: "uint32",
      },
      key: [],
    },
    Match: {
      schema: {
        id: "uint32",
        createdTimestamp: "uint256",
        extension: "string",
        map: "string",
        players: "address[]",
      },
      key: ["id"],
    },
    DoomMessages: {
      schema: {
        uid: "uint256",
        matchId: "uint32",
        lengths: "uint32[]",
        packets: "bytes",
      },
      key: ["uid"],
      type: "offchainTable",
    },
  },
});
